// Первое вхождение любого из акцентов. Из двух акцентов в одной позиции
// выигрывает длинный: иначе вложенный короткий разрезал бы длинный пополам
const findFirstAccent = (text, accentsList) => {
  let matchIndex = -1;
  let matchedAccent = null;

  accentsList.forEach((accent) => {
    const index = text.indexOf(accent);
    if (index === -1) return;
    const isEarlier = matchIndex === -1 || index < matchIndex;
    const isLongerAtSamePlace = index === matchIndex && accent.length > matchedAccent.length;
    if (isEarlier || isLongerAtSamePlace) {
      matchIndex = index;
      matchedAccent = accent;
    }
  });

  return {matchIndex, matchedAccent};
};

/**
 * Разбивает текст на куски по подстрокам-акцентам: обычные и те, что в верстке
 * подсвечиваются цветом. Так тексты в конфигах остаются читаемыми строками, а
 * не деревом из React-элементов.
 *
 * Ненайденный акцент молча игнорируется (текст отрисуется целиком без
 * подсветки) — за опечатки в акцентах отвечает тест конфига, а не рантайм.
 *
 * @param {string} text
 * @param {string[]} [accents] - дословные подстроки из text
 * @returns {{text: string, isAccent: boolean}[]}
 */
export const splitTextByAccents = (text, accents) => {
  if (!text) return [];

  const accentsList = (accents || []).filter((accent) => typeof accent === 'string' && accent.length > 0);
  if (accentsList.length === 0) return [{text, isAccent: false}];

  const parts = [];
  let rest = text;

  while (rest.length > 0) {
    const {matchIndex, matchedAccent} = findFirstAccent(rest, accentsList);

    if (matchIndex === -1) {
      parts.push({text: rest, isAccent: false});
      break;
    }

    if (matchIndex > 0) {
      parts.push({text: rest.slice(0, matchIndex), isAccent: false});
    }
    parts.push({text: matchedAccent, isAccent: true});
    rest = rest.slice(matchIndex + matchedAccent.length);
  }

  return parts;
};
